import React, { Component } from 'react';
import Breadcrumb from '../common/breadcrumb';
import './EinvoiceForm.css';
import LoadingLoader from "../Loader/Loader";
import SuccessAlert from '../CustomAlert/CustomAlertV2'
import ErrorAlert from '../CustomAlert/CustomAlertV2'

class EinvoiceForm extends Component {
    constructor(props) {
        super(props);
        const defaultData = { ...props.location.state.data };

        // Clear tinNo if it's "EI00000000010"
        if (defaultData.tinNo === 'EI00000000010') {
            defaultData.tinNo = '';
        }

        if (defaultData.sstNo === 'NA') {
            defaultData.sstNo = '';
        }

        this.state = {
            defaultData,
            orderId: props.location.state.id,
            invoiceType: defaultData.invoiceType || 'Individual',
            termsChecked: false,
            defaultChecked: false,
            formValid: false,
            loading: false,
            showSuccess: false,
            showError: false,
            errorMessage: '',
            successMessage: '',
            name: defaultData.fullName,
            identityType: defaultData.idType,
            identityNumber: defaultData.idNo,
            businessOrigin: defaultData.businessOrigin || 'Local',
            address1: defaultData.address1,
            address2: defaultData.address2,
            phone: defaultData.phoneNum,
            email: defaultData.email,
            tinNo: defaultData.tinNo,
            sstNo: defaultData.sstNo,

            nameError: '',
            identityTypeError: '',
            identityNumberError: '',
            address1Error: '',
            phoneError: '',
            emailError: '',
            businessOriginError: '',
            tinNoError: '',
        };
    }

    componentDidMount() {
        this.validateForm();
    }

    handleInvoiceTypeChange = (e) => {
        const newInvoiceType = e.target.value;
        this.setState(
            {
                invoiceType: newInvoiceType,
                termsChecked: false, // uncheck the checkbox
            },
            () => this.checkFormValidity(2) // run after state updates
        );
    };

    goBack = () => {
        const prevProduct = {
            pathname: `/order-history`,
        }
        this.props.history.push(prevProduct)
        window.location.reload()
    }

    closeSuccessModal = () => {
        this.setState({ showSuccess: false, showError: false })
        this.goBack();
        // back to previous screen
    }

    closeErrorModal = () => {
        this.setState({ showSuccess: false, showError: false })
    }

    handleInputChange = (e) => {
        const { id, value, type, checked } = e.target;
        const { defaultData } = this.state;

        if (id === 'termsCheck') {
            this.setState({ termsChecked: checked });
        }
    };

    setConfirmInfo = (e) => {
        const newConfirm = e.target.checked;
        this.setState({ termsChecked: newConfirm }, () => {
            this.checkFormValidity(2); // Called after termsChecked is updated
        });
    };

    setDefault = (e) => {
        const newDefault = e.target.checked;
        this.setState({ defaultChecked: newDefault }, () => {
        });
    };

    validateForm = () => {
        const { defaultData, invoiceType, termsChecked } = this.state;
        let isValid = true;

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const nameRegex = /^[A-Za-z0-9\s@\-]+$/;
        const phoneRegex = /^[0-9]{10,11}$/;
        const nricRegex = /^[0-9]{12}$/;
        const alphaNumRegex = /^[A-Za-z0-9]+$/;

        // Common required fields
        const requiredCommon = [
            (defaultData.fullName || '').trim(),
            (defaultData.idNo || '').trim(),
            (defaultData.address1 || '').trim(),
            (defaultData.phoneNum || '').trim(),
            (defaultData.email || '').trim()
        ];

        // Validate based on type
        if (invoiceType === 'Individual') {
            if (requiredCommon.includes('') || !(defaultData.idType && defaultData.idType.trim())) isValid = false;
            if (!nameRegex.test(defaultData.fullName)) isValid = false;
            if (!emailRegex.test(defaultData.email)) isValid = false;
            if (!phoneRegex.test(defaultData.phoneNum)) isValid = false;

            if (defaultData.idType === 'NRIC' && !nricRegex.test(defaultData.idNo)) isValid = false;
            if (defaultData.idType !== 'NRIC' && !alphaNumRegex.test(defaultData.idNo)) isValid = false;

        } else if (invoiceType === 'Company') {
            if (
                !(defaultData.businessOrigin && defaultData.businessOrigin.trim()) ||
                requiredCommon.includes('') ||
                !(defaultData.tinNo && defaultData.tinNo.trim())
            ) {
                isValid = false;
            }
            if (!emailRegex.test(defaultData.email)) isValid = false;
            if (!phoneRegex.test(defaultData.phoneNum)) isValid = false;
        }

        this.setState({ formValid: isValid && termsChecked });
    };

    validateName = (value, type) => {

        if (!value || value.trim().length === 0) {
            if (type == 1) {
                this.setState({ nameError: 'Please enter valid name' });

            }

            return false;
        } else {
            if (value.trim().length <= 4) {
                if (type == 1) {
                    this.setState({ nameError: 'Please enter valid name' });
                }

                return false;
            } else {
                const nameRegex = /^[A-Za-z0-9\-@ ]+$/;
                if (!value || !nameRegex.test(value)) {
                    if (type == 1) {
                        this.setState({ nameError: 'Please enter valid name' });
                    }

                    return false;
                }
            }
        }

        this.setState({ nameError: '' });
        return true;
    };


    setName = (e) => {
        this.setState({ name: e.target.value });
    };


    validateIdentityType = (value, type) => {
        this.validateIdentityNumber(value, this.state.identityNumber, type);
        this.validateBusinessOrigin(this.state.businessOrigin, this.state.tinNo, 2);

        // validateForm(1);
        if (this.state.invoiceType === 'Individual' && !value) {
            if (type == 1) {
                this.setState({ identityTypeError: 'Identity type is required.' });
            }

            return false;
        }
        this.setState({ identityTypeError: '' });
        return true;
    };



    validateIdentityNumber = (invoiceType, value, type) => {
        if (invoiceType === 'Company') {
            if (!/^[a-zA-Z0-9]+$/.test(value)) {
                if (type == 1) {
                    this.setState({ identityNumberError: 'Please enter valid Registration number.' });
                }

                return false;
            } else {
                this.setState({ identityNumberError: '' });
                return true;
            }
        } else if (invoiceType === 'Individual') {
            if (!value) {
                if (type == 1) {
                    this.setState({ identityNumberError: 'Please enter valid Identity number.' });
                }

                return false;
            } else {
                if (this.state.identityType === 'NRIC') {

                    if (value.trim().length < 12 || value.trim().length > 12) {
                        if (type == 1) {
                            this.setState({ identityNumberError: 'Please enter not more than 12 characters.' });
                        }

                        return false;
                    } else {
                        if (!/^\d{12}$/.test(value)) {
                            if (type == 1) {
                                this.setState({ identityNumberError: 'Please enter not more than 12 characters.' });
                            }

                            return false;
                        } else {
                            this.setState({ identityNumberError: '' });
                            return true;
                        }
                    }


                } else if (this.state.identityType == 'Passport') {
                    if (!value) {
                        if (type == 1) {
                            this.setState({ identityNumberError: 'Please enter valid Identity number.' });
                        }

                        return false;
                    } else {
                        if (!/^[a-zA-Z0-9]+$/.test(value)) {
                            if (type == 1) {
                                this.setState({ identityNumberError: 'Please enter valid Identity number.' });
                            }

                            return false;
                        } else {
                            this.setState({ identityNumberError: '' });
                            return true;
                        }
                    }

                }

                this.setState({ identityNumberError: '' });
                return true;
            }
        }
    };


    validateAddress1 = (value, type) => {
        if (!value || value.trim().length === 0) {
            if (type == 1) {
                this.setState({ address1Error: 'Please enter valid Address.' });
            }

            return false;
        } else {
            if (value.trim().length <= 4) {
                if (type == 1) {
                    this.setState({ address1Error: 'Please enter valid Address.' });
                }

                return false;
            } else {
                this.setState({ address1Error: '' });
                return true;
            }
        }

    };


    validatePhone = (value, type) => {
        if (value.trim().length < 10 || value.trim().length > 11) {
            if (type == 1) {
                this.setState({ phoneError: 'Please enter not more than 12 characters.' });
            }

            return false;
        } else {
            const phoneRegex = /^[0-9]{10,11}$/;
            if (!value || !phoneRegex.test(value)) {
                if (type == 1) {
                    this.setState({ phoneError: 'Please enter not more than 12 characters.' });
                }

                return false;
            } else {
                this.setState({ phoneError: '' });
                return true;
            }
        }


    };


    validateEmail = (value, type) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!value || !emailRegex.test(value)) {
            if (type == 1) {
                this.setState({ emailError: 'Please enter valid email address.' });
            }

            return false;
        }
        this.setState({ emailError: '' });
        return true;
    };


    validateBusinessOrigin = (origin, tin, type) => {
        if (this.state.invoiceType !== 'Company') return true;
        if (!origin) {
            if (type == 1) {
                this.setState({ businessOriginError: 'Business origin is required.' });
            }
            this.setIsFormValid(false);

            return false;
        }
        if (origin === 'Local' && !/^[a-zA-Z0-9]+$/.test(tin)) {
            if (type == 1) {
                this.setState({ tinNoError: 'Please enter valid TIN No.' });
            }

            return false;
        }
        this.setState({ businessOriginError: '' });
        this.setState({ tinNoError: '' });
        return true;
    };


    setIsFormValid = (value) => {
        this.state.formValid = value;
    };


    checkFormValidity = (type) => {
        const currentInvoiceType = this.state.invoiceType;
        const currentName = this.state.name;
        const currentIdentityNumber = this.state.identityNumber;
        const currentIdentityType = this.state.identityType;
        const currentAddress1 = this.state.address1;
        const currentPhone = this.state.phone;
        const currentEmail = this.state.email;
        const currentTinNo = this.state.tinNo;
        const currentBusinessOrigin = this.state.businessOrigin;
        const currentConfirmInfo = this.state.termsChecked;

        const isValid =
            this.validateName(currentName, type) &&
            this.validateIdentityType(currentIdentityType, type) &&
            this.validateIdentityNumber(currentInvoiceType, currentIdentityNumber, type) &&
            this.validateAddress1(currentAddress1, type) &&
            this.validatePhone(currentPhone, type) &&
            this.validateEmail(currentEmail, type) &&
            this.validateBusinessOrigin(currentBusinessOrigin, currentTinNo, type) &&
            currentConfirmInfo;

        this.setIsFormValid(isValid);

        return isValid;
    };

    submitForm = (e) => {
        e.preventDefault();
        const valid = this.checkFormValidity(1);
        if (!valid) return;

        const { defaultData, invoiceType, orderId } = this.state;

        const body = {
            orderId,
            buyerEmail: defaultData.buyerEmail,
            invoiceType: this.state.invoiceType,
            idType: invoiceType === 'Individual' ? (this.state.identityType || '') : 'BRN',
            idNo: this.state.identityNumber,
            fullName: this.state.name,
            phoneNum: this.state.phone,
            address1: this.state.address1,
            address2: this.state.address2 || '',
            email: this.state.email,
            tinNo: invoiceType === 'Individual' ? (this.state.tinNo && this.state.tinNo.trim() ? this.state.tinNo : "EI00000000010") : "EI00000000010",
            businessOrigin: invoiceType === 'Company' ? (this.state.businessOrigin || '') : '',
            sst: this.state.sstNo && this.state.sstNo.trim() ? this.state.sstNo : "NA",
            saveDefault: this.state.defaultChecked
        };

        this.setState({ loading: true });

        this.props.apiManager.makeCall('sendEinv', body, res => {
            this.setState({ loading: false });

            if (!res || !res.success) {
                this.setState({
                    showError: true,
                    errorMessage: (res && res.message) ? res.message : "Failed to submit request. Please try again",
                    loading: false
                });
            } else {
                this.setState({
                    showSuccess: true,
                    successMessage: (res && res.message) ? res.message : "Your e-invoice request has been submitted. Check your email for the invoice.",
                    loading: false
                });
            }
        });
    };

    render() {
        const { defaultData, invoiceType, termsChecked, formValid, } = this.state;

        if (this.state.loading)
            return (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '70vh' }}>
                    <LoadingLoader
                        visible={this.state.loading}
                    />
                </div>
            )

        return (
            <div className='eInvoiceSection'>
                <Breadcrumb title={'E-Invoice'} />
                <div className="container mt-5 mb-5">
                    <h3 className="einvoiceMainTitle text-center mb-2">REQUEST E-INVOICE</h3>
                    <p className="einvoiceSubtitle text-center mb-4">Please ensure your details are accurate.</p>

                    <form className="card p-4 mx-auto mainForm">
                        <div className="form-row mb-3">
                            <div className="form-group mb-3 col-md-6">
                                <label className="formLabelTitle">
                                    Invoice Type <span className="formLabelTitleAst">*</span>
                                </label>
                                <select
                                    className="form-control"
                                    id="invoiceType"
                                    value={this.state.invoiceType}
                                    onChange={this.handleInvoiceTypeChange}
                                >
                                    <option>Individual</option>
                                    <option>Company</option>
                                </select>
                            </div>
                        </div>

                        <hr className="dividerEinv mb-3" />

                        {invoiceType === 'Individual' && (
                            <div className="mt-3" id="idv">
                                <div className="form-row mb-3">
                                    <div className="form-group mb-3 col-md-6">
                                        <label className="formLabelTitle">
                                            Name as per IC <span className="formLabelTitleAst">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            id="fullName"
                                            className="form-control"
                                            placeholder="Purchaser Name"
                                            value={this.state.name}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                this.setState({ name: value }, () => {
                                                    this.validateName(value, 1);
                                                    this.checkFormValidity(2); // if needed
                                                });
                                            }}
                                            onBlur={(e) => {
                                                const value = e.target.value;
                                                this.setState({ name: value }, () => {
                                                    this.validateName(value, 1);
                                                    this.checkFormValidity(2); // if needed
                                                });
                                            }}
                                            maxLength={100}
                                        />
                                        {this.state.nameError ? <span className="formLabelTitleAst">{this.state.nameError}</span> : <span style={{ marginBottom: 2 }} />}
                                    </div>
                                </div>

                                <div className="form-row mb-3">
                                    <div className="form-group col-md-6">
                                        <label className="formLabelTitle">
                                            Identity Type <span className="formLabelTitleAst">*</span>
                                        </label>
                                        <select
                                            className="form-control"
                                            id="idType"
                                            value={this.state.identityType}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                this.setState({ identityType: value }, () => {
                                                    this.validateIdentityType(value, 1);
                                                    this.checkFormValidity(2); // if needed
                                                });
                                            }}
                                        >
                                            <option value="">Please select id type</option>
                                            <option>NRIC</option>
                                            <option>Passport</option>
                                        </select>
                                        {this.state.identityTypeError ? <span className="formLabelTitleAst">{this.state.identityTypeError}</span> : <span style={{ marginBottom: 2 }} />}
                                    </div>
                                    <div className="form-group col-md-6">
                                        <label className="formLabelTitle">
                                            Identity Number <span className="formLabelTitleAst">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            id="idNo"
                                            className="form-control"
                                            placeholder="Identity Number"
                                            value={this.state.identityNumber}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                this.setState({ identityNumber: value }, () => {
                                                    this.validateIdentityNumber(this.state.invoiceType, value, 1);
                                                    this.checkFormValidity(2); // if needed
                                                });
                                            }}
                                            onBlur={(e) => {
                                                const value = e.target.value;
                                                this.setState({ identityNumber: value }, () => {
                                                    this.validateIdentityNumber(this.state.invoiceType, value, 1);
                                                    this.checkFormValidity(2); // if needed
                                                });

                                            }}
                                            maxLength={30}
                                        />
                                        {this.state.identityNumberError ? <span className="formLabelTitleAst">{this.state.identityNumberError}</span> : <span style={{ marginBottom: 2 }} />}
                                    </div>
                                </div>
                            </div>
                        )}

                        {invoiceType === 'Company' && (
                            <div className="mt-3" id="com">
                                <div className="form-row mb-3">
                                    <div className="form-group mb-3 col-md-6">
                                        <label className="formLabelTitle">
                                            Business Origin <span className="formLabelTitleAst">*</span>
                                        </label>
                                        <select
                                            className="form-control"
                                            id="businessOrigin"
                                            value={this.state.businessOrigin}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                this.setState({ businessOrigin: value }, () => {
                                                    this.checkFormValidity(2); // if needed
                                                });
                                            }}
                                        >
                                            <option>Local</option>
                                            <option>Foreign</option>
                                        </select>
                                        {this.state.businessOriginError ? <span className="formLabelTitleAst">{this.state.businessOriginError}</span> : <span style={{ marginBottom: 2 }} />}
                                    </div>
                                </div>

                                <div className="form-row mb-3">
                                    <div className="form-group mb-3 col-md-6">
                                        <label className="formLabelTitle">
                                            Company Name <span className="formLabelTitleAst">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            id="fullName"
                                            className="form-control"
                                            placeholder="Company Name"
                                            value={this.state.name}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                this.setState({ name: value }, () => {
                                                    this.validateName(value, 1);
                                                    this.checkFormValidity(2); // if needed
                                                });
                                            }}
                                            onBlur={(e) => {
                                                const value = e.target.value;
                                                this.setState({ name: value }, () => {
                                                    this.validateName(value, 1);
                                                    this.checkFormValidity(2); // if needed
                                                });
                                            }}
                                            maxLength={100}
                                        />
                                        {this.state.nameError ? <span className="formLabelTitleAst">{this.state.nameError}</span> : <span style={{ marginBottom: 2 }} />}
                                    </div>

                                    <div className="form-group col-md-6">
                                        <label className="formLabelTitle">
                                            Registration Number <span className="formLabelTitleAst">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            id="idNo"
                                            className="form-control"
                                            placeholder="Registration Number"
                                            value={this.state.identityNumber}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                this.setState({ identityNumber: value }, () => {
                                                    this.validateIdentityNumber(this.state.invoiceType, value, 1);
                                                    this.checkFormValidity(2); // if needed
                                                });
                                            }}
                                            onBlur={(e) => {
                                                const value = e.target.value;
                                                this.setState({ identityNumber: value }, () => {
                                                    this.validateIdentityNumber(this.state.invoiceType, value, 1);
                                                    this.checkFormValidity(2); // if needed
                                                });
                                            }}
                                            maxLength={50}
                                        />
                                        {this.state.identityNumberError ? <span className="formLabelTitleAst">{this.state.identityNumberError}</span> : <span style={{ marginBottom: 2 }} />}
                                    </div>
                                </div>

                                <div className="form-row mb-3">
                                    <div className="form-group mb-3 col-md-6">
                                        <label className="formLabelTitle">
                                            Tax ID Number (TIN) <span className="formLabelTitleAst">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            id="tinNo"
                                            className="form-control"
                                            placeholder="Tax ID Number (TIN)"
                                            value={this.state.tinNo}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                this.setState({ tinNo: value }, () => {
                                                    this.validateBusinessOrigin(this.state.businessOrigin, value, 1);
                                                    this.checkFormValidity(2); // if needed
                                                });
                                            }}
                                            onBlur={(e) => {
                                                const value = e.target.value;
                                                this.setState({ tinNo: value }, () => {
                                                    this.validateBusinessOrigin(this.state.businessOrigin, value, 1);
                                                    this.checkFormValidity(2); // if needed
                                                });
                                            }}
                                            maxLength={25}
                                        />
                                        {this.state.tinNoError ? <span className="formLabelTitleAst">{this.state.tinNoError}</span> : <span style={{ marginBottom: 2 }} />}
                                    </div>

                                    <div className="form-group col-md-6">
                                        <label className="formLabelTitle">
                                            SST ID
                                        </label>
                                        <input
                                            type="text"
                                            id="sstNo"
                                            className="form-control"
                                            placeholder="SST ID (optional)"
                                            value={this.state.sstNo}
                                            onChange={this.handleInputChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        <hr className="dividerEinv mb-3" />

                        <div className="form-group mb-3">
                            <label className="formLabelTitle">
                                Detailed Address <span className="formLabelTitleAst">*</span>
                            </label>
                            <input
                                type="text"
                                id="address1"
                                className="form-control mb-2"
                                placeholder="Address Line 1"
                                value={this.state.address1}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    this.setState({ address1: value }, () => {
                                        this.validateAddress1(value, 1);
                                        this.checkFormValidity(2); // if needed
                                    });
                                }}
                                onBlur={(e) => {
                                    const value = e.target.value;
                                    this.setState({ address1: value }, () => {
                                        this.validateAddress1(value, 1);
                                        this.checkFormValidity(2); // if needed
                                    });
                                }}
                                maxLength={150}
                            />
                            {this.state.address1Error ? <span className="formLabelTitleAst">{this.state.address1Error}</span> : <span style={{ marginBottom: 2 }} />}
                            <input
                                type="text"
                                id="address2"
                                className="form-control"
                                placeholder="Address Line 2"
                                value={this.state.address2}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    this.setState({ address2: value }, () => {
                                        this.checkFormValidity(2); // if needed
                                    });
                                }}
                                onBlur={(e) => {
                                    const value = e.target.value;
                                    this.setState({ address2: value }, () => {
                                        this.checkFormValidity(2); // if needed
                                    });
                                }}
                                maxLength={150}
                            />
                        </div>

                        <div className="form-row mb-3">
                            <div className="form-group col-md-6">
                                <label className="formLabelTitle">
                                    Mobile Number <span className="formLabelTitleAst">*</span>
                                </label>
                                <input
                                    type="text"
                                    id="phoneNum"
                                    className="form-control"
                                    placeholder="0123456789"
                                    value={this.state.phone}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        this.setState({ phone: value }, () => {
                                            this.validatePhone(value, 1);
                                            this.checkFormValidity(2); // if needed
                                        });
                                    }}
                                    onBlur={(e) => {
                                        const value = e.target.value;
                                        this.setState({ phone: value }, () => {
                                            this.validatePhone(value, 1);
                                            this.checkFormValidity(2); // if needed
                                        });
                                    }}
                                    maxLength={11}
                                />
                                {this.state.phoneError ? <span className="formLabelTitleAst">{this.state.phoneError}</span> : <span style={{ marginBottom: 2 }} />}
                            </div>
                            <div className="form-group col-md-6">
                                <label className="formLabelTitle">
                                    Email Address <span className="formLabelTitleAst">*</span>
                                </label>
                                <input
                                    type="email"
                                    id="email"
                                    className="form-control"
                                    placeholder="Email Address"
                                    value={this.state.email}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        this.setState({ email: value }, () => {
                                            this.validateEmail(value, 1);
                                            this.checkFormValidity(2); // if needed
                                        });
                                    }}
                                    onBlur={(e) => {
                                        const value = e.target.value;
                                        this.setState({ email: value }, () => {
                                            this.validateEmail(value, 1);
                                            this.checkFormValidity(2); // if needed
                                        });
                                    }}
                                    maxLength={100}
                                />
                                {this.state.emailError ? <span className="formLabelTitleAst">{this.state.emailError}</span> : <span style={{ marginBottom: 2 }} />}
                            </div>
                        </div>

                        <div className="form-check mb-2">
                            <input type="checkbox" className="form-check-input" id="defaultCheck" checked={this.state.setDefault}
                                onChange={this.setDefault} />
                            <label className="form-check-label" htmlFor="defaultCheck">Set as Default</label>
                        </div>

                        <div className="form-check mb-4">
                            <input
                                type="checkbox"
                                className="form-check-input"
                                id="termsCheck"
                                checked={this.state.termsChecked}
                                onChange={this.setConfirmInfo}
                            />
                            <label className="form-check-label" htmlFor="termsCheck">
                                By continuing, I acknowledge that all information provided is correct and agreed to the{' '}
                                <a
                                    href="https://xox.com.my/terms-conditions/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Terms of Service & Privacy Policy
                                </a>.
                            </label>
                        </div>

                        <div className="einvSub">
                            <button
                                type="submit"
                                className="btn btn-dark btn-block einvSubBtn"
                                disabled={!this.state.formValid}
                                onClick={(e) => this.submitForm(e)}
                            >
                                Submit Request
                            </button>
                        </div>
                    </form>
                </div>

                <SuccessAlert
                    onClose={this.closeSuccessModal}
                    open={this.state.showSuccess}
                    title={'Request Submitted'}
                    message={this.state.successMessage}
                />
                <ErrorAlert
                    onClose={this.closeErrorModal}
                    open={this.state.showError}
                    error
                    title={'Error on Submit'}
                    message={this.state.errorMessage}
                />
            </div>
        );
    }
}

export default EinvoiceForm;
